import React, { createContext, useContext, useEffect, useState } from "react";
import { trackAddToCart } from "../lib/analytics";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const KEY = "bbs_cart";

function linePrice(item) {
  const extras = [...(item.customizations || []), ...(item.add_ons || [])].reduce((s, o) => s + (o.price || 0), 0);
  return (item.unit_price + extras) * item.quantity;
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const addItem = (entry) => {
    try { trackAddToCart({ id: entry.product_id, name: entry.name, value: linePrice(entry), quantity: entry.quantity }); } catch (e) {}
    setItems((prev) => {
      const key = JSON.stringify([entry.product_id, entry.variant, entry.customizations, entry.add_ons]);
      const idx = prev.findIndex((i) => JSON.stringify([i.product_id, i.variant, i.customizations, i.add_ons]) === key);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + entry.quantity };
        return copy;
      }
      return [...prev, { ...entry, lineId: Date.now() + Math.random() }];
    });
  };

  const updateQty = (lineId, delta) =>
    setItems((prev) => prev.map((i) => i.lineId === lineId ? { ...i, quantity: Math.max(1, i.quantity + delta) } : i));

  const removeItem = (lineId) => setItems((prev) => prev.filter((i) => i.lineId !== lineId));
  const clearCart = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + linePrice(i), 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clearCart, count, subtotal, linePrice }}>
      {children}
    </CartContext.Provider>
  );
}
